import * as React from 'react';

type AnsweringTabsProps = {
  onTabChange: (
    tab: string,
  ) => (event: React.MouseEvent<HTMLLabelElement, MouseEvent>) => void;
  activeTab: string;
};

const defaultBtnClass = 'btn btn-default';
const activeBtnClass = 'btn btn-info active';

const AdminAnsweringTabs: React.FunctionComponent<AnsweringTabsProps> = ({
  onTabChange,
  activeTab,
}) => (
  <div className="row">
    <div className="col-md-12 tabs-container">
      <label
        className={activeTab === 'info' ? activeBtnClass : defaultBtnClass}
        onClick={onTabChange('info')}
      >
        <i className="fa fa-phone"></i> Answering Service Provider
      </label>
      <label
        className={
          activeTab === 'timesettings' ? activeBtnClass : defaultBtnClass
        }
        onClick={onTabChange('timesettings')}
      >
        <i className="fa fa-calendar-times-o"></i> Time Settings
      </label>
    </div>
  </div>
);

export default AdminAnsweringTabs;
